var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWedge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 888",
    d: "M14.0887 3.21482L10.0067 0.813667L1.94568 12.8194L2.94044 13.677L6.02764 14.8433L14.0887 3.21482Z",
    fill: "#95E3FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 887",
    d: "M14.1573 10.6927V3.66075L13.0254 4.17528L6.09631 14.9805L14.1573 10.6927Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 885",
    d: "M14.123 3.11193L10.041 0.710777L1.84277 12.9224L5.99334 15.2892L14.123 10.5555V3.11193Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 886",
    d: "M13.9514 3.18053L5.85608 14.8776",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWedge);
export default __webpack_public_path__ + "static/media/wedge.40f614df22910eabf1807ff32f6775f7.svg";
export { ForwardRef as ReactComponent };